/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonFilterERP, ButtonPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GetCuentasBancariasByFiltersDtoProps } from "api/DTOs/GetCuentasBancariasByFiltersDto"
import { AnimatePresence } from "framer-motion"
import { Checkbox } from "primereact/checkbox"
import { Dialog } from "primereact/dialog"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { BankEntities, DEFAULT_BANK_LOGO_URL } from "./constants"

export const FilterMenu = ({
  uniqueEntities = [],
  setBancosFiltered,
  listBankAccounts,
}: {
  uniqueEntities: BankEntities[] | undefined
  setBancosFiltered: React.Dispatch<
    React.SetStateAction<GetCuentasBancariasByFiltersDtoProps[]>
  >
  listBankAccounts: GetCuentasBancariasByFiltersDtoProps[] | null | undefined
}) => {
  const { t } = useTranslation()
  const [menuOpen, setMenuOpen] = useState(false)

  const [selectedBank, setSelectedBank] = useState<Array<string>>([])

  const openFilters = () => {
    setMenuOpen(true)
  }

  const handleApplyFilters = () => {
    setMenuOpen(false)
  }
  const hideFilter = () => {
    setMenuOpen(!menuOpen)
  }

  const aplicateFilter = (selected: string[]) => {
    const newValue =
      selected.length === 0
        ? listBankAccounts
        : listBankAccounts?.filter(
            (bank: GetCuentasBancariasByFiltersDtoProps) =>
              selected.find(
                (selected: string) => selected === bank.entidadBancaria?.nombre
              )
          )
    setBancosFiltered(newValue ?? [])
  }

  const handleCheckboxChange = ({ value }: $TSMigrationFixMe) => {
    setSelectedBank((prevSelectedBank) => {
      if (prevSelectedBank.includes(value.entidad)) {
        aplicateFilter(
          prevSelectedBank.filter((bank) => bank !== value.entidad)
        )
        return prevSelectedBank.filter((bank) => bank !== value.entidad)
      }
      aplicateFilter([...prevSelectedBank, value.entidad])
      return [...prevSelectedBank, value.entidad]
    })
  }
  const handleResetFilters = () => {
    setSelectedBank([])
    aplicateFilter([])
  }

  const appliedFiltersTags = [
    {
      label: t("bancos.filter.bankEntity"),
      value: selectedBank?.length ? selectedBank.length : null,
      action: () => {
        setSelectedBank([])
        aplicateFilter([])
      },
    },
  ]
  const appliedFilters = appliedFiltersTags.filter((filter) => filter.value)

  return (
    <>
      <ButtonFilterERP
        isActive={appliedFilters.length > 0}
        numberActive={selectedBank?.length}
        onClick={openFilters}
        deleteFilter={handleResetFilters}
        filterButtonLabel={`${t("filtros.title")}`}
      />

      <AnimatePresence>
        <Dialog
          breakpoints={{ "575px": "100vw" }}
          className='!tw-m-0 !tw-h-full tw-select-none '
          header={t("filtros.title")}
          visible={menuOpen}
          footer={
            <div className='tw-w-full tw-border-t-2 tw-pt-6'>
              <ButtonPrimeReact
                className='tw-ml-2 !tw-bg-primary tw-cursor-pointer !tw-w-full'
                onClick={handleApplyFilters}
              >
                {t("filtros.labelApply")}
              </ButtonPrimeReact>
            </div>
          }
          onHide={() => {
            hideFilter()
          }}
          draggable={false}
          resizable={false}
          position='right'
          closable
          dismissableMask
          closeOnEscape
        >
          {Boolean(appliedFilters[0]?.value) && (
            <div className='tw-mb-8'>
              <div className='tw-flex tw-mb-4 tw-justify-between'>
                <span className='tw-font-medium'>
                  {t("tickets.filter.appliedFilters")}
                </span>
                <span
                  onClick={handleResetFilters}
                  className='tw-text-text-hyperlinks tw-cursor-pointer'
                >
                  {t("tickets.filter.deleteAll")}
                </span>
              </div>
              <div className='tw-flex tw-flex-wrap tw-mb-8 tw-gap-2 tw-font-normal tw-text-xs'>
                {appliedFilters.map((filter) => (
                  <div
                    key={filter.label}
                    onClick={filter.action}
                    className='tw-items-center tw-justify-between tw-cursor-pointer tw-bg-info-10 tw-text-info tw-rounded-md tw-border tw-border-info tw-py-1 tw-px-2'
                  >
                    <span>
                      {filter.label} ({filter.value})
                    </span>
                    <FontAwesomeIcon
                      icon={["fal", "xmark"]}
                      className='tw-ml-2 tw-text-info'
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className='tw-mb-8'>
            <div className='tw-mb-4'>
              <span className='tw-font-medium'>
                {t("bancos.table.headerEntBank")}
              </span>
            </div>
            <div className='tw-w-full tw-overflow-y-auto '>
              {uniqueEntities?.map((category: $TSMigrationFixMe) => {
                return (
                  <div
                    key={category.entidad}
                    className='tw-flex tw-flex-row tw-items-start tw-justify-start tw-h-fit tw-my-2.5'
                  >
                    <Checkbox
                      inputId={category.entidad}
                      name='category'
                      className='tw-mx-1'
                      value={category}
                      onChange={handleCheckboxChange}
                      checked={selectedBank.some(
                        (item: $TSMigrationFixMe) => item === category.entidad
                      )}
                    />

                    <img
                      src={
                        category.logo ? category.logo : DEFAULT_BANK_LOGO_URL
                      }
                      className='tw-w-6 tw-h-6 tw-rounded tw-ml-3'
                      alt={category.entidad}
                    />

                    <label
                      htmlFor={category.key}
                      className='tw-ml-2 tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-flex-1'
                    >
                      {category.entidad}
                    </label>
                  </div>
                )
              })}
            </div>
          </div>
        </Dialog>
      </AnimatePresence>
    </>
  )
}
